import { render, staticRenderFns } from "./PufaStatementUse.vue?vue&type=template&id=4b99ef66&scoped=true"
import script from "./PufaStatementUse.vue?vue&type=script&lang=js"
export * from "./PufaStatementUse.vue?vue&type=script&lang=js"
import style0 from "./PufaStatementUse.vue?vue&type=style&index=0&id=4b99ef66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b99ef66",
  null
  
)

export default component.exports